var React = require('react');

function IconEnvelop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M36.3636 22.2222H33.5664V25H36.3636V22.2222Z","fill":"#170F4F","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 25H30.7692V22.2222H2.7972V4.57227L18.1818 17.0723L33.5664 4.57226V19.4444H36.3636V0L0 0L0 25ZM31.3577 2.77778H5.0059L18.1818 13.4832L31.3577 2.77778Z","fill":"#170F4F","key":1})]);
}

IconEnvelop.defaultProps = {"width":"37","height":"25","viewBox":"0 0 37 25","fill":"none"};

module.exports = IconEnvelop;

IconEnvelop.default = IconEnvelop;
